import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
  headers: { Accept: "application/json" },
});

let refreshInFlight = null;
const authFreeEndpoints = ["/api/auth/login", "/api/auth/register", "/api/auth/refresh", "/api/auth/forgot-password", "/api/auth/reset-password"];

api.interceptors.request.use((config) => {
  if (typeof FormData !== "undefined" && config.data instanceof FormData) delete config.headers["Content-Type"];
  return config;
});

api.interceptors.response.use((response) => response, async (error) => {
  const request = error.config;
  const isAuthFreeRequest = authFreeEndpoints.some((endpoint) => request?.url?.includes(endpoint));
  if (error?.response?.status !== 401 || !request || request._sessionRetried || isAuthFreeRequest) return Promise.reject(error);
  request._sessionRetried = true;
  try {
    if (!refreshInFlight) refreshInFlight = axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshInFlight = null; });
    await refreshInFlight;
  } catch (refreshError) {
    window.dispatchEvent(new Event("mobilecart:session-expired"));
    return Promise.reject(refreshError);
  }
  window.dispatchEvent(new Event("mobilecart:session-recovered"));
  return api(request);
});

export async function restoreSession() {
  try {
    const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`, {}, { withCredentials: true });
    return data;
  } catch (refreshError) {
    const { data } = await api.get("/api/auth/me");
    return data;
  }
}

export function apiError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || String(item)).join(" ");
  return "Something went wrong. Please try again.";
}

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

// Subtle dark placeholder shown when product image fails to load
export const PLACEHOLDER_IMAGE = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400' viewBox='0 0 400 400'%3E%3Crect width='400' height='400' fill='%230a1223'/%3E%3Crect x='1' y='1' width='398' height='398' fill='none' stroke='%231e3a5f' stroke-width='2'/%3E%3Cpath d='M160 140 L200 100 L240 140 L240 260 L160 260 Z' fill='%231e3a5f'/%3E%3Ccircle cx='200' cy='180' r='20' fill='%2300d4ff' opacity='0.3'/%3E%3Ctext x='200' y='295' text-anchor='middle' font-family='monospace' font-size='11' fill='%2300d4ff' opacity='0.5'%3EImage not available%3C/text%3E%3C/svg%3E";

export function resolveMediaUrl(url) {
  if (!url) return PLACEHOLDER_IMAGE;
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
  // Relative paths like /api/media/... or /api/uploads/... need backend prefix
  return `${BACKEND}${url}`;
}

export const cardProduct = (product) => ({
  ...product,
  image: resolveMediaUrl(product.images?.[0]),
  old: product.original_price,
});